import { Typography } from "antd";

export const PreviewTitle = ({ title }: { title: string }) => {
  return (
    <Typography.Title
      level={3}
      style={{ padding: 0, margin: 0, fontWeight: 500, fontFamily: "Poppins" }}
    >
      {title}
    </Typography.Title>
  );
};
